import { render } from "./ShowInterpellation.vue?vue&type=template&id=44571ac7&scoped=true"
import script from "./ShowInterpellation.vue?vue&type=script&lang=js"
export * from "./ShowInterpellation.vue?vue&type=script&lang=js"

import "./ShowInterpellation.vue?vue&type=style&index=0&id=44571ac7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44571ac7"]])

export default __exports__